import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "account-info" }
const _hoisted_2 = { style: {"box-sizing":"border-box","padding":"20px 0"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1)
const _hoisted_11 = {
  key: 0,
  style: {"border-top":"16px solid #f2f4f8"}
}
const _hoisted_12 = { style: {"text-align":"center"} }
const _hoisted_13 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "我同意遵守", -1)
const _hoisted_15 = { class: "affix" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }

import { ref, watch } from 'vue';
import {
  BaseForm,
  BaseButton,
  BaseSteps,
  BaseStep,
  BaseTableProps,
  useTableColumn,
  BaseCheckbox,
  BaseTable,
  BaseTextContent,
  BaseTextTitle,
  BaseLink,
  BaseScrollbar
} from 'xrk-components';
import {
  AccountInfoBook,
  AccountInfoInout,
  AccountInfoElectron,
  AccountInfoFy,
  AccountInfoCompany,
  AccountInfoLegal,
  AccountInfoBank,
  AccountInfoHandled,
  AccountInfoBeneficiary,
  AccountInfoShareholder
} from '../components/account-info';
import infoStore from '../store/info';
import { storeToRefs } from 'pinia';
import { useRoute, LocationQuery, useRouter } from 'vue-router';
import { PayPassagewayCode, AuthStatus } from '@/common/types/bank';
import { formatter } from '@/utils';

interface RouteQuery extends LocationQuery {
  payPassagewayCode: PayPassagewayCode;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'account-info',
  setup(__props) {

const AUTH_RESP_STATUS = {
  1: {
    label: '审核中',
    value: 1
  },
  2: {
    label: '通过',
    value: 2
  },
  3: {
    label: '不通过',
    value: 3
  }
};
const AUTH_LIST_FIELD = [
  {
    label: '向日葵审核记录',
    value: 'platformAuthList'
  },
  {
    label: '支付通道审核记录',
    value: 'bankAuthList'
  }
];
const AUDITH_STEP: Record<AuthStatus, any> = {
  0: { active: 0, processStatus: 'process', title: '企业信息录入' },
  1: { active: 1, processStatus: 'process', title: '企业信息人工审核' },
  2: { active: 1, processStatus: 'error', title: '企业信息人工审核' },
  3: { active: 1, processStatus: 'success', title: '企业信息人工审核' },
  4: { active: 2, processStatus: 'process', title: '银行审核' },
  5: { active: 2, processStatus: 'error', title: '银行审核' },
  6: { active: 3, processStatus: 'success', title: '开通成功' },
  7: { active: 3, processStatus: 'error', title: '已关闭' }
};

const routeQuery = useRoute().query as RouteQuery;
const router = useRouter();

const store = infoStore();
const { authLists, formData, agree, bank, disabled, formRef } =
  storeToRefs(store);
const { onSubmit, init, setPayPassagewayCode } = store;

const step = ref<{
  active: number;
  processStatus: 'wait' | 'process' | 'finish' | 'error' | 'success';
}>({
  active: 0,
  processStatus: 'process'
});
const steps = ref([]);

const columns = ref<BaseTableProps['columns']>([
  useTableColumn({
    label: '审核结果',
    prop: 'authStatus',
    formatter: ({ cellValue }) =>
      formatter.defaultFormat(
        cellValue,
        () => AUTH_RESP_STATUS[cellValue].label
      )
  }),
  useTableColumn({
    label: '原因',
    prop: 'auditRemark',
    formatter: ({ cellValue }) => formatter.defaultFormat(cellValue)
  }),
  useTableColumn({
    label: '时间',
    prop: 'auditAt',
    formatter: ({ cellValue }) => formatter.date(cellValue)
  })
]);

watch(
  () => bank.value,
  v => {
    steps.value = [
      AUDITH_STEP[0].title,
      AUDITH_STEP[1].title,
      AUDITH_STEP[4].title,
      v.platformAuthStatus === 7
        ? AUDITH_STEP['7'].title
        : AUDITH_STEP['6'].title
    ];

    step.value = {
      active: AUDITH_STEP[v.platformAuthStatus].active,
      processStatus: AUDITH_STEP[v.platformAuthStatus].processStatus
    };
  }
);

const onCancel = () => {
  router.go(-1);
};

setPayPassagewayCode(routeQuery.payPassagewayCode);
init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BaseSteps), {
        "finish-status": "success",
        simple: "",
        active: step.value.active,
        "process-status": step.value.processStatus
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (item, index) => {
            return (_openBlock(), _createBlock(_unref(BaseStep), {
              key: index,
              title: item
            }, null, 8, ["title"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["active", "process-status"])
    ]),
    _hoisted_3,
    _createVNode(_unref(BaseScrollbar), { always: "" }, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseForm), {
          ref_key: "formRef",
          ref: formRef,
          "label-position": "top",
          disabled: _unref(disabled),
          model: _unref(formData)
        }, {
          default: _withCtx(() => [
            (_unref(bank).platformAuthStatus === 6)
              ? (_openBlock(), _createBlock(_unref(AccountInfoBook), { key: 0 }))
              : _createCommentVNode("", true),
            _hoisted_4,
            _createVNode(_unref(AccountInfoFy)),
            _hoisted_5,
            _createElementVNode("template", null, [
              _createVNode(_unref(AccountInfoInout)),
              _createVNode(_unref(AccountInfoElectron))
            ]),
            _createVNode(_unref(AccountInfoCompany)),
            _hoisted_6,
            _createVNode(_unref(AccountInfoLegal)),
            _hoisted_7,
            _createVNode(_unref(AccountInfoBank)),
            _hoisted_8,
            _createVNode(_unref(AccountInfoHandled)),
            _hoisted_9,
            (['10', '12'].includes(_unref(formData).fyChannel))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_unref(AccountInfoBeneficiary)),
                  _hoisted_10,
                  _createVNode(_unref(AccountInfoShareholder))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["disabled", "model"]),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(AUTH_LIST_FIELD, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.label + Date.now()
          }, [
            (_unref(authLists)[item.value]?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_unref(BaseTextTitle), { class: "account-info__items__title" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(BaseTextContent), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BaseTable), {
                        columns: columns.value,
                        data: _unref(authLists)[item.value]
                      }, null, 8, ["columns", "data"])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 64)),
        _createElementVNode("div", _hoisted_12, [
          (!_unref(disabled))
            ? (_openBlock(), _createBlock(_unref(BaseCheckbox), {
                key: 0,
                style: {"margin-bottom":"24px"},
                modelValue: _unref(agree),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(agree) ? (agree).value = $event : null)),
                trueValue: 1,
                falseValue: 0
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_unref(BaseLink), {
                      type: "primary",
                      href: "//cdn.yxvzb.com/WEB/SaaS/agreement/fy/富友-向日葵平台专用账户协议.docx",
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 《富友支付开户三方协议》 ")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_15, [
      (!_unref(disabled))
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_unref(BaseButton), {
              type: "default",
              onClick: onCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseButton), {
              disabled: !_unref(agree),
              click: _unref(onSubmit)
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交")
              ]),
              _: 1
            }, 8, ["disabled", "click"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_unref(BaseButton), {
              type: "default",
              onClick: onCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode("返回")
              ]),
              _: 1
            })
          ]))
    ])
  ]))
}
}

})